import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Register = () => {
  const [username, setUsername] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [city, setCity] = useState('');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const { registerUser } = useAuth();
  const nav = useNavigate();

  const handleRegister = async () => {
    setErrors({});
    setIsLoading(true);
    try {
      const success = await registerUser(
        {
          username,
          first_name: firstName,
          last_name: lastName,
          phone_number: phoneNumber,
          city,
          address,
          email,
          password,
          confirm_password: passwordConfirm,
        },
        setErrors
      );

      if (success) {
        toast.success('Registration successful!');
        setTimeout(() => nav('/login'), 1500);
      } else {
        toast.error('Registration failed. Please check your inputs.');
      }
    } catch (error) {
      toast.error('An unexpected error occurred.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleNavigate = () => {
    nav('/login');
  };

  return (
    <section className="h-100">
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col">
            <div className="card card-registration my-4">
              <div className="row g-0">
                <div className="col-xl-6 d-none d-xl-block">
                  <img
                    src="https://cdn.pixabay.com/photo/2014/04/10/11/06/tomatoes-320860_1280.jpg"
                    alt="Sample"
                    className="img-fluid"
                    style={{
                      borderTopLeftRadius: '.25rem',
                      borderBottomLeftRadius: '.25rem',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>
                <div className="col-xl-6">
                  <div className="card-body p-md-5 text-black">
                    <h3 className="mb-5 text-uppercase">User Registration</h3>

                    <div className="form-outline mb-4">
                      <input
                        type="text"
                        id="username"
                        className="form-control form-control-lg"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        disabled={isLoading}
                      />
                      {errors.username && <small className="text-danger">{errors.username}</small>}
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          placeholder="First Name"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          disabled={isLoading}
                        />
                        {errors.first_name && <small className="text-danger">{errors.first_name}</small>}
                      </div>
                      <div className="col-md-6 mb-4">
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          placeholder="Last Name"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          disabled={isLoading}
                        />
                        {errors.last_name && <small className="text-danger">{errors.last_name}</small>}
                      </div>
                    </div>

                    <div className="form-outline mb-4">
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Phone Number"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        disabled={isLoading}
                      />
                      {errors.phone_number && <small className="text-danger">{errors.phone_number}</small>}
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          placeholder="City"
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                          disabled={isLoading}
                        />
                        {errors.city && <small className="text-danger">{errors.city}</small>}
                      </div>
                      <div className="col-md-6 mb-4">
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          placeholder="Address"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          disabled={isLoading}
                        />
                        {errors.address && <small className="text-danger">{errors.address}</small>}
                      </div>
                    </div>

                    <div className="form-outline mb-4">
                      <input
                        type="email"
                        className="form-control form-control-lg"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={isLoading}
                      />
                      {errors.email && <small className="text-danger">{errors.email}</small>}
                    </div>

                    <div className="form-outline mb-4">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className="form-control form-control-lg"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={isLoading}
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary mt-2"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? 'Hide' : 'Show'} Password
                      </button>
                      {errors.password && <small className="text-danger">{errors.password}</small>}
                    </div>

                    <div className="form-outline mb-4">
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        className="form-control form-control-lg"
                        placeholder="Confirm Password"
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                        disabled={isLoading}
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary mt-2"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      >
                        {showConfirmPassword ? 'Hide' : 'Show'} Confirm
                      </button>
                      {errors.confirm_password && (
                        <small className="text-danger">{errors.confirm_password}</small>
                      )}
                    </div>

                    <div className="d-flex justify-content-end pt-3">
                      <button
                        type="button"
                        className="btn btn-light btn-lg"
                        onClick={() => {
                          setUsername('');
                          setFirstName('');
                          setLastName('');
                          setPhoneNumber('');
                          setCity('');
                          setAddress('');
                          setEmail('');
                          setPassword('');
                          setPasswordConfirm('');
                          setErrors({});
                        }}
                      >
                        Reset all
                      </button>
                      <button
                        type="button"
                        className="btn logo btn-lg ms-2"
                        onClick={handleRegister}
                        disabled={isLoading}
                      >
                        {isLoading ? 'Registering...' : 'Submit form'}
                      </button>
                    </div>

                    <p className="text-muted small mt-3" role="button" onClick={handleNavigate}>
                      Have an account? <span className="text-primary">Sign in</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Register;
